import type { ReactElement } from 'react'

import { mtc } from '@/styles'
import { Image } from '@/ui'
import { ALI_PHOTO_URL, ROBBY_PHOTO_URL } from './constants'

export const HostAvatars = ({ size }: { size: 'sm' | 'md' }): ReactElement => {
  const photoClass = mtc(
    'rounded-full border-2 border-neutral-0',
    size === 'md' ? 'size-12' : 'size-8'
  )
  return (
    <div className="flex shrink-0">
      <Image src={ROBBY_PHOTO_URL} alt="Robby" className={photoClass} />
      <Image
        src={ALI_PHOTO_URL}
        alt="Ali"
        className={mtc(photoClass, '-ml-3')}
      />
    </div>
  )
}
